import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PropensityHierarchyNode } from '@/services/api';

export interface PropensityHierarchyState {
  node: PropensityHierarchyNode | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: PropensityHierarchyState = {
  node: null,
  isLoading: false,
  error: null
};

export const FETCH_PROPENSITY_HIERARCHY_REQUESTED = 'propensityHierarchy/FETCH_REQUESTED';
export const FETCH_PROPENSITY_HIERARCHY_SUCCEEDED = 'propensityHierarchy/FETCH_SUCCEEDED';
export const FETCH_PROPENSITY_HIERARCHY_FAILED = 'propensityHierarchy/FETCH_FAILED';

export const fetchPropensityHierarchyRequested = (payload?: { target_employee_id?: string; target_role?: string; hierarchy_path?: string }) => ({
  type: FETCH_PROPENSITY_HIERARCHY_REQUESTED,
  payload
});

export const fetchPropensityHierarchySucceeded = (payload: PropensityHierarchyNode) => ({
  type: FETCH_PROPENSITY_HIERARCHY_SUCCEEDED,
  payload
});

export const fetchPropensityHierarchyFailed = (payload: string) => ({
  type: FETCH_PROPENSITY_HIERARCHY_FAILED,
  payload
});

const propensityHierarchySlice = createSlice({
  name: 'propensityHierarchy',
  initialState,
  reducers: {
    setPropensityHierarchyLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setPropensityHierarchyError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setPropensityHierarchyNode(state, action: PayloadAction<PropensityHierarchyNode | null>) {
      state.node = action.payload;
    }
  }
});

export const { setPropensityHierarchyLoading, setPropensityHierarchyError, setPropensityHierarchyNode } = propensityHierarchySlice.actions;

export default propensityHierarchySlice.reducer;


